<template>
	<div>
		<v-row v-if="error_msg.length !== 0" class="ma-0">
			<v-col cols="12">
				<v-alert type="error" class="mb-0">
					{{ error_msg }}
				</v-alert>
			</v-col>
		</v-row>
		<ProgressLinear v-if="loading"/>
		<v-row v-if="!loading" class="ma-0">		
			<v-col v-if="$vuetify.breakpoint.smAndDown ? !is_create && task_id === 0 : true" :cols="$vuetify.breakpoint.smAndDown? 12:3">
				<v-row class="ma-0" justify="space-between">
					<v-btn class="text-capitalize white--text" :color="color" @click="is_create = true; hex = {r: 0, g: 0, b: 0}; task_id = 0">
						<v-icon>mdi-plus</v-icon>
						New Task Status
					</v-btn>
					<v-btn v-if="$vuetify.breakpoint.smAndDown" icon @click="$emit('close');">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-row>
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 260}px`">
					<div class="list-wrap-container">
						<v-expansion-panels
							v-model="panel"
							multiple
							accordion
							flat
						>
							<v-expansion-panel
								v-for="item in panel_items"
								:key="item.value"
							>
								<v-expansion-panel-header class="py-2 px-3" style="min-height: 48px;">
									<template v-slot:actions>
										<v-icon class="icon mr-2">$expand</v-icon>
									</template>
									<span class="header">{{ item.title }}</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list-item-title v-for="status in status_group[`${item.value}`]" :key="status.id" class="task-status-hover rounded" @click="onShowTaskStatus(status, item.value)">
										<v-badge
											class="my-2"
											:color="status.rgba"
											left
											inline
											dot
										>
											<span class="ml-2" :style="!status.is_active ? `text-decoration-line: line-through; opacity: 0.5; color: ${status.rgba}`:`color: ${status.rgba}`">{{status.description }}</span>
											<span class="ml-2 rounded-pill inactive-text px-2" v-if="!status.is_active">Inactive</span>
											<span class="ml-2 rounded-pill default-text px-2" v-if="status.is_default">Default</span>
										</v-badge>
									</v-list-item-title>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</div>
				</div>
			</v-col>
			<v-col v-if="$vuetify.breakpoint.smAndDown ? !is_create && task_id !== 0 : !is_create" :cols="$vuetify.breakpoint.smAndDown? 12:9">
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 224}px`">
					<div class="list-wrap-container">
						<v-row :class="$vuetify.breakpoint.smAndDown ? 'mt-0 mx-0 mb-3':'ma-0'" justify="space-between">
							<v-row class="ma-0">
								<v-btn outlined class="text-capitalize" :color="color" @click="onDuplicate()">
									<v-icon small class="mr-1">mdi-content-copy</v-icon>
									Duplicate
								</v-btn>
								<v-btn outlined class="text-capitalize mx-3" :color="`#F45252`" @click="onDelete()">
									<v-icon size="20" class="mr-1">mdi-delete-outline</v-icon>
									Delete
								</v-btn>
								<v-btn v-if="isDetailChange && !$vuetify.breakpoint.smAndDown" class="text-capitalize white--text" :color="color" elevation="0" @click="onSaveChange()">
									<SaveIcon class="mr-1" :color="'white'" width="20" height="20"/>
									Save changes
								</v-btn>
							</v-row>
							<v-btn icon @click="onClose()">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-row>
						<v-row class="mt-3 mx-0 mb-2" v-if="isDetailChange && $vuetify.breakpoint.smAndDown">
							<v-btn block class="text-capitalize white--text" :color="color" elevation="0" @click="onSaveChange()">
								<SaveIcon class="mr-1" :color="'white'" width="20" height="20"/>
								Save changes
							</v-btn>
						</v-row>
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" class="pl-0">
								<v-row class="ma-0">
									<div class="title-text title-text-color mr-2">
										Task status group
									</div>
									<v-tooltip attach right max-width="calc(55%)" z-index="11">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on">
												<InfoOutline width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
											</div>
										</template>
										<span>JobBag has 4 default task status types.</span>
									</v-tooltip>
								</v-row>
								<v-select
									v-model="select_status_group"
									:items="panel_items"
									:menu-props="{ bottom: true, offsetY: true}"
									:color="color"
									background-color="#FAFAFA"
									:item-color="color"
									item-text="title"
									outlined
									dense
									hide-details
								>
								</v-select>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:8" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
								<v-row class="ma-0">
									<div class="title-text mr-2" :class="!task_desc || (task_desc && task_desc.length === 0) ? 'title-text-color-red' : 'title-text-color'">
										Task status name
									</div>
									<v-tooltip attach right max-width="calc(55%)" z-index="11">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on">
												<InfoOutline width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
											</div>
										</template>
										<span>Use this field to write a description of what this task status means. Users in your organisation will see this when they click on the information icon.</span>
									</v-tooltip>
								</v-row>
								<v-text-field
									v-model="task_desc"
									:color="color"
									:error="!task_desc || (task_desc && task_desc.length === 0)"
									background-color="#FAFAFA"
									outlined
									hide-details
									clearable
									dense
								></v-text-field>
							</v-col>
						</v-row>
						<div class="title-text title-text-color">Set task status colour</div>
						<v-color-picker
							v-model="taskColor"
							class="mt-1"
							canvas-height="120"
							hide-mode-switch
						></v-color-picker>
						<v-checkbox
							class="mt-2"
							v-model="status_for_new_task"
							:color="color"
							hide-details
							dense
						>
							<template v-slot:label>
								<span class="mr-2 checkbox-text">Default status for new tasks</span>
								<v-tooltip attach right max-width="calc(55%)" z-index="11">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
										</div>
									</template>
									<span>Pre-fills Task status field with this status when a new Task is created.</span>
								</v-tooltip>
							</template>
						</v-checkbox>
						<v-checkbox
							class="mt-2"
							v-model="status_inactive"
							:color="color"
							hide-details
							dense
						>
							<template v-slot:label>
								<span class="mr-2 checkbox-text">Mark as inactive</span>
								<v-tooltip attach right max-width="calc(55%)" z-index="11">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
										</div>
									</template>
									<span>Disables this Task status for new tasks and new jobs created. Also disables changing old tasks back to this status</span>
								</v-tooltip>
							</template>
						</v-checkbox>
					</div>
				</div>
			</v-col>
			<v-col v-if="is_create" :cols="$vuetify.breakpoint.smAndDown? 12:9">
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.smAndDown ? $vuetify.breakpoint.height - 260 :$vuetify.breakpoint.height - 224}px`">
					<div class="list-wrap-container">
						<v-row class="ma-0" justify="space-between">
							<v-row class="ma-0">
								<v-btn class="text-capitalize white--text" :color="color" elevation="0" :disabled="!isCreateAvailable" @click="onCreate()">
									Create Status 
								</v-btn>
							</v-row>
							<v-btn icon @click="onClose()">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-row>
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" class="pl-0">
								<v-row class="ma-0">
									<div class="title-text title-text-color mr-2">
										Task status group
									</div>
									<v-tooltip attach right max-width="calc(55%)" z-index="11">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on">
												<InfoOutline width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
											</div>
										</template>
										<span>JobBag has 4 default task status types.</span>
									</v-tooltip>
								</v-row>
								<v-select
									v-model="create_status_group"
									:items="panel_items"
									:menu-props="{ bottom: true, offsetY: true}"
									color="rgba(25, 42, 62, 0.7)"
									background-color="#FAFAFA"
									:item-color="color"
									item-text="title"
									outlined
									dense
									hide-details
								>
								</v-select>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:8" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
								<v-row class="ma-0">
									<div class="title-text mr-2" :class="!create_desc || (create_desc && create_desc.length === 0) ? 'title-text-color-red' : 'title-text-color'">
										Task status name
									</div>
									<v-tooltip attach right max-width="calc(55%)" z-index="11">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on">
												<InfoOutline width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
											</div>
										</template>
										<span>Use this field to write a description of what this task status means. Users in your organisation will see this when they click on the information icon.</span>
									</v-tooltip>
								</v-row>
								<v-text-field
									v-model="create_desc"
									:color="color"
									:error="!create_desc || (create_desc && create_desc.length === 0)"
									background-color="#FAFAFA"
									outlined
									hide-details
									clearable
									dense
								></v-text-field>
							</v-col>
						</v-row>
						<div class="title-text title-text-color">Set task status colour</div>
						<v-color-picker
							v-model="createColor"
							class="mt-1"
							canvas-height="120"
							hide-mode-switch
						></v-color-picker>
						<v-checkbox
							class="mt-2"
							v-model="create_for_new_task"
							:color="color"
							hide-details
							dense
						>
							<template v-slot:label>
								<span class="mr-2 checkbox-text">Default status for new tasks</span>
								<v-tooltip attach top max-width="calc(55%)" z-index="11">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
										</div>
									</template>
									<span>Pre-fills Task status field with this status when a new Task is created.</span>
								</v-tooltip>
							</template>
						</v-checkbox>
						<v-checkbox
							class="mt-2"
							v-model="create_inactive"
							:color="color"
							hide-details
							dense
						>
							<template v-slot:label>
								<span class="mr-2 checkbox-text">Mark as inactive</span>
								<v-tooltip attach top max-width="calc(55%)" z-index="11">
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
										</div>
									</template>
									<span>Disables this Task status for new tasks and new jobs created. Also disables changing old tasks back to this status</span>
								</v-tooltip>
							</template>
						</v-checkbox>
					</div>
				</div>
			</v-col>
		</v-row>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<DeleteConfirmDialog 
			v-if="unsaved_visible"
			:visible="unsaved_visible" 
			:color="'error'"
			:title="`Your changes have not been saved`" 
			:content="'Are you sure you want to leave this page without saving changes?'"
			:cancel="'Go back'"
			:ok="'Yes, leave'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="unsaved_visible = false"
			@ok="onLeave()"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="del_title" 
			:content="del_content"
			:cancel="'Go back'"
			:ok="del_ok"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDeleteStatus()"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import SaveIcon from "@/components/icons/save.vue";
import InfoOutline from "@/components/icons/info_outline";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

/** from src/db/models/planning.rs */
const Panel_Items = [
	{
		title: 'Potential',
		value: 0
	},
	{
		title: 'Pending',
		value: 1
	},
	{
		title: 'Active',
		value: 2
	},
	{
		title: 'Completed',
		value: 3
	},
	{
		title: 'Stuck',
		value: 4
	}
];

export default {
	name: 'TaskStatus',
	components: {
		ProgressLinear,
		SaveIcon,
		InfoOutline,
		DialogNotice,
		DeleteConfirmDialog
	},
	props: {
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		this.panel_items = Panel_Items;

		return {
			error_msg: '',
			loading: false,

			panel: this.id === 0 ? [0] :Panel_Items.map((k, i) => { return i}),
			status_group: null,
			task_statuses: [],

			select_status_group: 0,
			task_id: 0,
			task_desc: '',
			hex: { r: 0, g: 0, b: 0 },
			status_for_new_task: false,
			status_inactive: false,

			is_create: false,
			create_status_group: 2,
			create_desc: '',
			create_for_new_task: false,
			create_inactive: false,

			del_title: '',
			del_content: '',
			del_ok: '',

			visible_notice: false,
			notice_text: [],
			tid: null,

			unsaved_visible: false,
			delete_visible: false,
		}
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		await this.getTaskStatus();

		const first_key = (Object.keys(this.status_group))[0];
		const first_status_arr = this.status_group[`${first_key}`];
		const first_open_status = first_status_arr[0];

		if (!this.$vuetify.breakpoint.smAndDown) {
			this.onShowTaskStatus(first_open_status, Number(first_key));
		}
	},
	computed: {
		isDetailChange() {
			let is_change = false;

			if (this.task_id !== 0) {
				const origin_task = this.task_statuses.filter(t => { return t.id === this.task_id });
				const color_rgb = `rgb(${this.taskColor.r},${this.taskColor.g},${this.taskColor.b})`;

				if (origin_task[0].status_type !== this.select_status_group
					|| (origin_task[0].description !== this.task_desc && this.task_desc)
					|| origin_task[0].is_default !== this.status_for_new_task 
					|| origin_task[0].is_active === this.status_inactive
					|| origin_task[0].color_rgb !== color_rgb
				) {
					is_change = true;
				}
			}

			return is_change;
		},
		isCreateAvailable() {
			let is_available = false;
			if (this.is_create) {
				if (this.create_desc && this.create_desc.length !== 0) {
					is_available = true;
				}
			}
			return is_available;
		},
		taskColor: {
			get () {
				return this['hex']
			},
			set (v) {
				this['hex'] = v
			},
		},
		createColor: {
			get () {
				return this['hex']
			},
			set (v) {
				this['hex'] = v
			},
		}
	},
	watch: {
		isDetailChange() {
			this.$emit('change', this.isDetailChange);
		},
		is_create() {
			this.$emit('change', this.is_create);
		}
	},
	methods: {
		async getTaskStatus() {
			this.loading = true;

			const url = '/api/config/jobs/task';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.task_statuses = data;

						const status_group_obj = {};

						this.panel_items.forEach(element => {
							status_group_obj[`${element.value}`] = [];
						});

						data.forEach(d => {
							d['rgba'] = d.color_rgb;

							(status_group_obj[`${d.status_type}`]).push(d);
						});

						this.status_group = status_group_obj;						

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onShowTaskStatus(status, group_value) {
			if (this.is_create) {
				this.is_create = false;
			};

			this.select_status_group = group_value;
			this.task_id = status.id;
			this.task_desc = status.description;
			this.hex = this._getRgbaValue(status.rgba);
			this.status_for_new_task = status.is_default;
			this.status_inactive = !status.is_active;
		},
		onDuplicate() {
			this.create_status_group = this.select_status_group;
			this.create_desc = this.task_desc;
			this.create_for_new_task = this.status_for_new_task;
			this.create_inactive = this.status_inactive;
			this.is_create = true;
		},
		onSaveChange() {
			const param_obj = {};
			param_obj['is_active'] = !this.status_inactive;
			param_obj['is_default'] = this.status_for_new_task;
			param_obj['status_type'] = this.select_status_group;
			param_obj['description'] = this.task_desc;
			param_obj['color'] = this._rgbToDecimal(this.taskColor);

			this._changeTaskStatus(param_obj);
		},
		onDelete() {
			const current_task_status = this.task_statuses.filter(status => { return status.id === this.task_id });
			const is_used = current_task_status[0].is_used;

			if (is_used) {
				this.del_title = 'Task Status in use';
				this.del_content = 'This Task status cannot be deleted as it is in use. It can be marked inactive, if you don’t want it to be used for future Jobs. ';
				this.del_ok = 'Mark inactive';
				this.delete_visible = true;

			} else {
				this.del_title = `You are about to delete Task Status ‘${current_task_status[0].description}’`;
				this.del_content = 'This action cannot be undone. Are you sure?';
				this.del_ok = 'Yes, delete';
				this.delete_visible = true;
			}
		},
		onDeleteStatus() {
			const current_task_status = this.task_statuses.filter(status => { return status.id === this.task_id });
			const is_used = current_task_status[0].is_used;

			if (is_used) {
				const param_obj = {};
				param_obj['is_active'] = false;
				param_obj['is_default'] = current_task_status[0].is_default;
				param_obj['status_type'] = current_task_status[0].status_type;
				param_obj['description'] = current_task_status[0].description;
				param_obj['color'] = current_task_status[0].color;

				this._changeTaskStatus(param_obj);
			} else {
				this._deleteTaskStatus(current_task_status[0])
			}
		},
		onCreate() {
			const param_obj = {};
			param_obj['is_active'] = !this.create_inactive;
			param_obj['is_default'] = this.create_for_new_task;
			param_obj['status_type'] = this.create_status_group;
			param_obj['description'] = this.create_desc;
			param_obj['color'] = this._rgbToDecimal(this.createColor);

			const url = `/api/config/jobs/task/`;
			axios
				.post(url, param_obj, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this._initCreateSettings();
						
						this.getTaskStatus();

						this.notice_text.push('Task Status has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						if (this.$vuetify.breakpoint.smAndDown) {
							this._initEditSettings();
							this._initCreateSettings();
						} else {
							const first_key = (Object.keys(this.status_group))[0];
							const first_status_arr = this.status_group[`${first_key}`];
							const first_open_status = first_status_arr[0];
							this.onShowTaskStatus(first_open_status, Number(first_key));	
						}

					} else {
						this.error_msg = reason;
					}
					
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onClose() {
			if (this.isDetailChange || this.isCreateAvailable) {
				this.unsaved_visible = true;
			} else {
				if (this.$vuetify.breakpoint.smAndDown) {
					this._initEditSettings();
					this._initCreateSettings();						
				} else {
					this.$emit('close');
				}
			}
		},
		onLeave() {
			if (this.$vuetify.breakpoint.smAndDown) {
				this.unsaved_visible = false;
				this._initEditSettings();
				this._initCreateSettings();
			} else {
				this.$emit('close');
			}
		},
		async _changeTaskStatus(param_obj) {
			const url = `/api/config/jobs/task/${this.task_id}`;
			axios
				.put(url, param_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;
					if (status == "OK") {
						this.getTaskStatus();

						this.notice_text.push('Task Status has been updated successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);	

						if (this.delete_visible) {
							this.delete_visible = false;

							if (this.$vuetify.breakpoint.smAndDown) {
								this.unsaved_visible = false;
								this._initEditSettings();
							} else {
								const first_key = (Object.keys(this.status_group))[0];
								const first_status_arr = this.status_group[`${first_key}`];
								const first_open_status = first_status_arr[0];

								this.onShowTaskStatus(first_open_status, Number(first_key));
							}
							
						} else {
							if (this.$vuetify.breakpoint.smAndDown) {
								this.unsaved_visible = false;
								this._initEditSettings();
							} else {
								const color = this._getRGBFromDecimal(data.color);
								data['rgba'] = color;
								this.onShowTaskStatus(data, data.status_type);
							}
							
						}
										
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_deleteTaskStatus(task_status) {
			const url = `/api/config/jobs/task/${task_status.id}`;

			axios
				.delete(url, {
				}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;

						this.getTaskStatus();

						this.notice_text.push('Task Status has been deleted successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
						
						if (this.$vuetify.breakpoint.smAndDown) {
							this.unsaved_visible = false;
							this._initEditSettings();
							
						} else {
							const first_key = (Object.keys(this.status_group))[0];
							const first_status_arr = this.status_group[`${first_key}`];
							const first_open_status = first_status_arr[0];

							this.onShowTaskStatus(first_open_status, Number(first_key));
						}						

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
		_getRGBFromDecimal(number) {
			const b = Math.floor(number / (256*256));
			const g = Math.floor(number / 256) % 256;
			const r = number % 256;
			
			return `rgba(${r},${g},${b})`;
		},
		_getRgbaValue(rgba_str) {
			const value_str = rgba_str.substring(rgba_str.indexOf('(') + 1, rgba_str.lastIndexOf(')'));
			const color_value = value_str.split(',');
			const value = { r: color_value[0], g: color_value[1], b: color_value[2] };

			return value;
		},
		_rgbToDecimal(rgba_obj) {
			const r = rgba_obj.r & 0xFF;
			const g = rgba_obj.g & 0xFF;
			const b = rgba_obj.b & 0xFF;

			const rgb = (b << 16) + (g << 8) + (r);
			return rgb;
		},
		_initEditSettings() {
			this.task_id = 0;
			this.select_status_group = 0;
			this.task_desc = '';
			this.hex = { r: 0, g: 0, b: 0 };
			this.status_for_new_task = false;
			this.status_inactive = false;
		},
		_initCreateSettings() {
			this.is_create = false;
			this.create_status_group = 2;
			this.create_desc = '';
			this.create_for_new_task = false;
			this.create_inactive = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.list-wrap {
	overflow: auto;
}
.list-wrap-container {
  height: 99%;
}
	.title-text {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
	}
	.title-text-color {
		color: rgba(55, 73, 95, 1);
	}
	.title-text-color-red {
		color: rgba(244, 82, 82, 1);
	}
	.inactive-text {
		background-color: rgba(232, 234, 236, 1);
		font-family: Roboto;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(25, 42, 62, 0.7);
	}
	.default-text {
		background-color: rgba(220, 220, 220, 1);
		font-family: Roboto;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(25, 42, 62, 1);
	}
	.checkbox-text {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: rgba(25, 42, 62, 0.5);
	}
	.task-status-hover {
		&:hover {
			background-color: #FAFAFA;
			cursor: pointer;
		}
	}
	.icon {
	  order: 0;
	}

	.header {
	  order: 1;
	}

	::v-deep  {
		.v-color-picker__input input {
			background-color: rgba(25, 42, 62, 0.15);
		}
	}	
</style>